module.exports = __webpack_public_path__ + "img/category-fishing-game.9083dec9.png";